// `mc-admin` is deliberately scoped to Mission Control + Members only and is
// NOT granted Insights or Canopus Command — see commit d758c5d.
//
// TODO: remove temporary `mc-viewer` access to Canopus Command — revert to
// `canopus-viewer` only.
const PAGE_ACCESS = {
    members: {
        view: [],
        edit: ['admin', 'mc-admin', 'mc-editor', 'cc-editor'],
    },
    missionControl: {
        view: ['mc-admin', 'mc-viewer'],
        edit: ['mc-admin', 'mc-editor'],
    },
    insights: {
        view: ['insights-viewer'],
        edit: [],
    },
    commandCenter: {
        view: ['cc-viewer'],
        edit: ['cc-editor'],
    },
    canopusCommand: {
        view: ['canopus-viewer', 'mc-viewer'],
        edit: [],
    },
    brandBook: {
        view: ['admin', 'brand-viewer'],
        edit: ['admin', 'brand-editor'],
    },
};
function unique(roles) {
    return [...new Set(roles)];
}
const pageKeys = Object.keys(PAGE_ACCESS);
/**
 * Roles that may open a page and fetch its read-only data. Editors are
 * included, so granting only `mc-editor` / `brand-editor` / `cc-editor`
 * still opens the page.
 */
export const PAGE_VIEW_ROLES = Object.fromEntries(pageKeys.map((key) => [key, unique([...PAGE_ACCESS[key].view, ...PAGE_ACCESS[key].edit])]));
/** Roles that may mutate a page's data. */
export const PAGE_EDIT_ROLES = Object.fromEntries(pageKeys.map((key) => [key, unique(PAGE_ACCESS[key].edit)]));
/**
 * `GET /api/insights/facilities` backs both the Insights facility picker and
 * the Canopus Command facility picker, so it must accept every role that can
 * open either page. Derived here so adding a role to either page picks this
 * endpoint up for free.
 */
export const FACILITY_LIST_ROLES = unique([
    ...PAGE_VIEW_ROLES.insights,
    ...PAGE_VIEW_ROLES.canopusCommand,
]);
//# sourceMappingURL=pageAccess.js.map